import { CSSObject } from '@chakra-ui/react';

export const Wrapper: CSSObject = {
  h: ['75px', null, '125px'],
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  mt: ['65vw', '55vw', '288px'],
};

export const TextItem = {
  color: 'white',
  textAlign: 'center',
  fontSize: 'sm',
  fontStyle: 'normal',
  fontWeight: 'normal',
};

export const LinkItem = {
  color: 'beta.400',
  fontWeight: 'bold',
};
